// Screen point ({ x, y }) of a Leaflet marker click: the marker's own position, so the popup grows out of
// its centre rather than wherever on it the click landed.
export const markerScreenPoint = (event) => {
    const target = event?.target;
    const map = target?._map;
    if (map && typeof target.getLatLng === 'function') {
        const rect = map.getContainer().getBoundingClientRect();
        const point = map.latLngToContainerPoint(target.getLatLng());
        return { x: rect.left + point.x, y: rect.top + point.y };
    }
    const original = event?.originalEvent;
    return original && Number.isFinite(original.clientX) ? { x: original.clientX, y: original.clientY } : null;
};
